import React from "react"

import { BodyCopyRegular, Box, Headline } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { Section } from "../LandingPage.styles"
import { FeatureFlag, useFeatureFlag } from "../../../hooks/use-feature-flag"
import { FaqButton, SubmitButton } from "../../styles"
import { colors } from "@theguarantors/ui-kit-v2/dist/design-system/colors"
import { FAQMessage } from "@theguarantors/ui-kit-v2"

const faqButton = () => window.open("https://www.theguarantors.com/faq-for-renters", "_blank")
const contactButton = () => window.open("https://www.theguarantors.com/contact-us", "_blank")

export const StillHaveQuestions: React.FC = () => {
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const rebrandV2MonolithReactFeatureFlag: Boolean = rebrandV2MonolithReact === "on"

  const [newGetStartedPage] = useFeatureFlag(FeatureFlag.NEW_GET_STARTED_PAGE)
  const newGetStartedPageFeatureFlag: boolean = newGetStartedPage === "on"

  const [newStillHaveQuestionsDesign] = useFeatureFlag(FeatureFlag.NEW_STILL_HAVE_QUESTIONS_DESIGN)
  const newStillHaveQuestionsDesignFeatureFlag = newStillHaveQuestionsDesign === "on"

  if (newStillHaveQuestionsDesignFeatureFlag) {
    return (
      <Box margin="6rem 0 10rem 0">
        <FAQMessage onContactUsClick={contactButton} onFAQsClick={faqButton} />
      </Box>
    )
  }

  if (newGetStartedPageFeatureFlag) {
    return (
      <Section
        as="article"
        textAlign={["center", "center", "left"]}
        width={["100%", "100%", "35%"]}
        pl={[0, 0, "2.4rem"]}
        margin="5rem 0 8rem 0"
      >
        <Headline size="xl" color={colors.v2_black} fontFamily="ivar" fontWeight="400" margin="14px 0 32px">
          Still have questions?
        </Headline>
        <BodyCopyRegular fontFamily="acid" color={colors.v2_black}>
          Give us a call at{" "}
          <a href="tel:+12122660020" style={{ color: "inherit" }}>
            +1 212-266-0020
          </a>
          ,
        </BodyCopyRegular>
        <BodyCopyRegular fontFamily={"acid"} color={colors.v2_black}>
          or check out our Frequently Asked Questions.
        </BodyCopyRegular>
        <Box mt="32px">
          <SubmitButton
            onClick={faqButton}
            variant={rebrandV2MonolithReactFeatureFlag ? "v2_primary" : "primary"}
            newGetStartedPageFeatureFlag={newGetStartedPageFeatureFlag}
            fontFamily={"acid"}
          >
            {"View FAQs"}
          </SubmitButton>
        </Box>
      </Section>
    )
  }

  return (
    <Section
      as="article"
      pt="2rem"
      textAlign={["center", "center", "left"]}
      width={["100%", "100%", "25%"]}
      pl={[0, 0, "2.4rem"]}
    >
      <Headline color="violet">Still have questions?</Headline>
      <BodyCopyRegular>
        Give us a call at <a href="tel:+12122660020">+1 212-266-0020</a>,
      </BodyCopyRegular>
      <BodyCopyRegular>or check out our Frequently Asked Questions.</BodyCopyRegular>
      <Box mt="6rem" mb="6rem">
        <FaqButton onClick={faqButton} variant={rebrandV2MonolithReactFeatureFlag ? "v2_primary" : "primary"}>
          FAQ
        </FaqButton>
      </Box>
    </Section>
  )
}
